import type { TourConfig } from '../../types/tour.types'

// Lead Scoring list. Anchors are `data-tour` attributes on the view (added alongside this tour),
// so the targets stay stable. Teaches context first, controls last.
const leadScoringTour: TourConfig = {
  id: 'lead-scoring',
  title: 'Score your leads',
  module: 'Enrichment',
  routeName: 'LeadScoring',
  order: 9,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Chase the best-fit leads first',
      body: 'Lead Scoring grades a list of companies against your **Ideal Customer Profile (ICP)**, so instead of working a list top-to-bottom you go after the ones most likely to buy.',
    },
    {
      id: 'new',
      target: '[data-tour="ls-new"]',
      placement: 'bottom',
      title: 'Start a scoring run',
      body: 'Upload a list of companies and we score each one against your ICP. You\'ll need at least one **ICP** first — if you don\'t have one, we\'ll offer to set it up here.',
    },
    {
      id: 'settings',
      target: '[data-tour="ls-settings"]',
      placement: 'bottom',
      title: 'Tune what "good" means',
      body: 'Settings opens your **ICPs** — the criteria your companies are scored against. Adjust them to change how scores are calculated.',
    },
    {
      id: 'jobs',
      target: '[data-tour="ls-jobs"]',
      placement: 'top',
      title: 'Your results land here',
      body: 'Every scoring run shows up in this list. Open a run\'s **report** to see each company\'s score and work the best-fit leads first.',
    },
  ],
}

export default leadScoringTour
